export default "/images/chart2.jpg?e20ddae1bc29926e81c41622d7b59951";